import React, { useEffect, useState } from "react";
import { Autocomplete, Box, CircularProgress, TextField } from "@mui/material";
import "./Support.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import {
  assignSupportTicket,
  assignSupportTicketNew,
  getSupportUsers,
  updateComplaint,
} from "../../services/supportService";
import { modelDataType } from "../../components/userModal/userModalType";
import { formInputsType, SupportModalType } from "./SupportTypes";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { getMetaDataConfig } from "../../services/uiConfigService";
import { configurationAttributeType } from "../../types";
import { Loader } from "../../components/loader/Loader";

const SupportModal = ({
  close,
  modelData,
  divison,
  genricModalData,
  canWeMakeRequest,
}: SupportModalType) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT = "Support"
  const [showLoader, setShowLoader] = useState(false);
  const [showUserFiled, setShowUserField] = useState(false);
  const [asignee, setAsignee] = useState<modelDataType[]>();
  const [error, setError] = useState(false);
  const [formInputs, setFormInputs] = useState<formInputsType | null>(null);
  const [selectedUser, setSelectedUser] = useState<string>("");
  const [newSupport, setNewSupport] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const toNullableString = (value: string | null | undefined): string | null => value ?? null;
  const normalizeFormInputs = (inputs: Partial<formInputsType>): formInputsType => ({
  id: inputs.id ?? null,
  complaint: inputs.complaint ?? null,
  status: inputs.status ?? null,
  remarks: inputs.remarks ?? null,
  role: inputs.role ?? null,
  user: inputs.user ?? null,
  formUser: inputs.user ?? null,
});

  const checkAllfieldPresent = (formInputs: formInputsType) => {
    const AllValueArray = Object.values(formInputs);
    if (AllValueArray.includes(null) || AllValueArray.includes("")) {
      setError(true);
      return false;
    }
    return true;
  };

  const uploadSupportTrack = async (formInputs: formInputsType) => {
    const requestBody = {
      escalationRemarks: formInputs.remarks,//remarks
      escalatiorId: JSON.parse(localStorage.authContext).user.loginId,//remove this
      immediateId: formInputs.user,
      loginId: JSON.parse(localStorage.authContext).user.loginId,
      supportId: newSupport ? modelData.supportId : modelData.support_id,
    };
    try {
      return await assignSupportTicket(requestBody);
    } catch (error) {
      return error;
    }
  };

  const updateSupport = async (formInputs: formInputsType, token: string) => {
    const requestBody = {
      immediateId: formInputs.user,
      remarks: formInputs.remarks,
      status: formInputs.status,
    };
    try {
      return await updateComplaint(requestBody, token);
    } catch (error) {
      return error;
    }
  };

  const updateSupportNew = async (formInputs: formInputsType) => {
    const requestBody = {
      immediateId: formInputs.user,
      remarks: formInputs.remarks,
      status: formInputs.status,
     extendedAttributes: {
      ...(modelData.extendedAttributes || {}), 
      role: formInputs.role,                 
      user: formInputs.formUser                 
    }
    };
    try {
      return await updateComplaint(requestBody,formInputs?.id ?? "");
    } catch (error) {
      return error;
    }
  };
  const uploadSupportData = async (formInputs: formInputsType) => {
    if (canWeMakeRequest()) {
      try {
        const selectedUser = asignee?.filter((user: modelDataType) => {
          return user.name === formInputs.user;
        });
        const requestBody: formInputsType = {
          ...formInputs,
          user: selectedUser ? selectedUser?.[0]?.loginId : formInputs.user,
          formUser:formInputs.user,
        }
        // let response = await uploadSupportTrack(requestBody);
        let token = "";
        if(!newSupport) {
         let response = await uploadSupportTrack(requestBody);
         token = response.data.feature.supportId;
        }
        // response = await updateSupport(requestBody, token);
        let response = newSupport? await updateSupportNew(requestBody) : await updateSupport(requestBody, token);
        if (response.status === 200) {
          genricModalData(
            "Complaint has been reassigned successfully.",
            "Success"
          );
        } else {
          throw error;
        }
      } catch (error) {
        genricModalData("Something went wrong. Please try again.", "Error");
      }
    }
    close();
  };

  const getUsers = async (role: string | null) => {
    if (role) {
      const response = await getSupportUsers(role);
      const allAsignee = response.data.features;
      setAsignee(allAsignee);
    }
  };
  const fetchPortalConfig = async () => {
  try {
    const portalConfig = await getMetaDataConfig(
      "clientConfig",
      "portal_configuration"
    );

    const portal_config: configurationAttributeType[] =
      portalConfig?.domainValues ?? [];

    const supportConfig = portal_config.find(
      (item) => item.name === "newSupport"
    )?.value ?? false;

    setNewSupport(supportConfig);

    if (modelData) {
      setFormInputs({
        id: toNullableString(supportConfig ? modelData.supportId : modelData.support_id),
        role: toNullableString(supportConfig ? modelData.extendedAttributes?.role : modelData.extendedAttributes?.role),
        complaint: toNullableString(supportConfig ? modelData.supportClass : modelData.support_class),
        status: toNullableString(modelData.status),
        user: toNullableString(supportConfig ? modelData.extendedAttributes?.user : modelData.extendedAttributes?.user),
        formUser: toNullableString(supportConfig ? modelData.extendedAttributes?.user : modelData.extendedAttributes?.user),
        remarks: toNullableString(modelData.remarks),
      });
      const userPresent = supportConfig ? modelData?.extendedAttributes.role : modelData.extendedAttributes?.role
      if(userPresent){
        setShowUserField(true);
        getUsers(userPresent);
      }
    }
  } catch (error) {
    console.error("Error fetching portal config:", error);
    setNewSupport(false); 
  } finally {
    setLoading(false);
  }
};
  const fetchAllRequiredData = async () => {
    await fetchPortalConfig();
  };

  useEffect(() => {
    fetchAllRequiredData();
  }, []);

  return (
    <Box className="helpdesk-modal-box">
      {loading ? (
           <Loader sx={{ position: "absolute", top: "55%" }} />
         ) : (
          <>
      <div className="helpdesk-modal-header">
        <p>{translate(TranslationEnum.support,"Help Desk")}</p>
        <FontAwesomeIcon
          className="helpdesk-model-sign"
          fontSize="30px"
          icon={faXmark}
          onClick={() => {
            setShowUserField(false);
            close();
          }}
        />
      </div>
      <div className="helpdesk-modal-body">
        <div className="helpdesk-modal-child">
          <TextField
            label={translate(TranslationEnum.support,"id")}
            id="outlined-start-adornment"
            value={newSupport ? modelData?.supportId: modelData?.support_id}
            // value={modelData?.support_id}
            disabled={true}
          />
          <Autocomplete
            disablePortal
            sx={{ width: "100%" }}
            onChange={(event, value: string | null) => {
              setShowUserField(true);
              getUsers(value);
              setFormInputs(normalizeFormInputs({ ...formInputs, role: value, user: null }));
            }}
            // defaultValue={translate(TranslationEnum.support,"Select Role")}
            value={formInputs?.role ? formInputs.role : translate(TranslationEnum.support,"Select Role")}
            options={divison ? divison : []}
            renderInput={(params) => <TextField {...params} label={
        <span>
          {translate(TranslationEnum.support, "Role")}
          <span style={{ color: "red" }}> *</span>
        </span>
      } />}
          />
          {showUserFiled && (
            <Autocomplete
              disablePortal
              sx={{ width: "100%" }}
              value={formInputs?.user ? formInputs.user : translate(TranslationEnum.support,"Select Assignee")}
              onChange={(event, value: string | null | undefined) => {
                if (value) {
                setFormInputs(normalizeFormInputs({ ...formInputs, user: value }));
                setSelectedUser(value);
                }
              }}
              options={
                asignee
                  ? asignee.map((user: modelDataType) => {
                    return user.name;
                  })
                  : []
              }
              renderInput={(params) => <TextField {...params} label={
        <span>
          {translate(TranslationEnum.support,"User")}
          <span style={{ color: "red" }}> *</span>
        </span>
      }/>}
            />
          )}
          <TextField
             label={
        <span>
          {translate(TranslationEnum.support,"Complaint")}
          <span style={{ color: "red" }}> *</span>
        </span>
      }
            id="outlined-start-adornment"
            value={newSupport ? modelData?.supportClass: modelData?.support_class}
            // value={modelData?.support_class}
            disabled={true}
          />
          <Autocomplete
            disablePortal
            sx={{ width: "100%" }}
            onChange={(event, value: string | null) => {
              setFormInputs(normalizeFormInputs({ ...formInputs, status: value }));
            }}
            value={formInputs?.status}
            defaultValue={translate(TranslationEnum.support,"Select Status")}
            options={["OPEN", "Pending", "Processing", "Completed"]}
            renderInput={(params) => <TextField {...params} label={
        <span>
          {translate(TranslationEnum.support,"Status")}
          <span style={{ color: "red" }}> *</span>
        </span>
      } />}
          />
          <TextField
            label={<span>{translate(TranslationEnum.support,"Remark")} <span style={{ color: 'red' }}>*</span></span>}
            id="outlined-start-adornment"
            value={formInputs?.remarks}
            onChange={(e) => {
               setFormInputs(normalizeFormInputs({ ...formInputs,  remarks: e.target.value  }));
            }}
            multiline
            rows={1}
          />
          {error ? (
            <p className="helpdesk-modal-warning">{translate(TranslationEnum.support,"All fields are mandatory")}!</p>
          ) : null}
        </div>
      </div>
      <div className="helpdesk-modal-footer">
        <button
          className="helpdesk-modal-button"
          onClick={() => {
            if (formInputs && checkAllfieldPresent(formInputs)) {
              setShowLoader(true);
              !showLoader && uploadSupportData(formInputs);
            }
          }}
        >
          {showLoader ? (
            <div>
              <CircularProgress size={15} color="inherit" />
              <span className="circular-progress-container">{translate(TranslationEnum.common_portal,"SUBMIT")}</span>
            </div>
          ) : (
            <>{translate(TranslationEnum.common_portal,"SUBMIT")}</>
          )}
        </button>
        <button
          className="helpdesk-modal-button cancel-button"
          onClick={() => {
            setShowUserField(false);
            close();
          }}
        >
          {translate(TranslationEnum.common_portal,"CANCEL")}
        </button>
      </div>
      </>
         )
        }
    </Box>
  );
};

export default SupportModal;
